export class RecentItemModel {
    lastVisited: string;
    path: string;

    constructor(lastVisited: string, path: string) {
        this.lastVisited = lastVisited;
        this.path = path;
    }

}
